import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f348271a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jeroen/VirtualHosts/deduursportcoach.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f348271a')) {
      api.createRecord('f348271a', component.options)
    } else {
      api.reload('f348271a', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=f348271a&", function () {
      api.rerender('f348271a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/App.vue"
export default component.exports